import React from 'react';

function LoadingState() {
  return (<div className="lr-loading-state" />);
}

export default LoadingState;
